const plugins = {};

plugins.install = function (Vue) {
    /*数组比较排序*/
    Vue.prototype.compare = sign => {
        return function (a, b) {
            var value1 = a[sign];
            var value2 = b[sign];
            return value1 - value2;
        }
    };
    /*数据类型判断*/
    Vue.prototype.ObjectRest = obj => {
        for (var _key in obj) {
            var type = Object.prototype.toString.call(obj[_key]);
            switch (type) {
                case '[object String]':
                    obj[_key] = '';
                    break;
                case '[object Number]':
                    obj[_key] = 0;
                    break;
                case '[object Boolean]':
                    obj[_key] = true;
                    break;
                case '[object Undefined]':
                    obj[_key] = undefined;
                    break;
                case '[object Null]':
                    obj[_key] = null;
                    break;
                case '[object Object]':
                    obj[_key] = {};
                    break;
                case '[object Array]':
                    obj[_key] = [];
                    break;
                default:
            }
        }
    };
    /*空对象判断*/
    Vue.prototype.isObject = obj => {
        for (var _key in obj) {
            return false;
        };
        return true;
    };
    /*清除数据的响应式*/
    Vue.prototype.clearObj = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    };
    /*清除对象的空属性*/
    Vue.prototype.clearEmpty = (obj) => {
        for (var _key in obj) {
            var type = Object.prototype.toString.call(obj[_key]);
            switch (type) {
                case '[object String]':
                    if (obj[_key] == '') {
                        delete obj[_key];
                    }
                    break;
                case '[object Number]':
                    if (obj[_key] == 0) {
                        delete obj[_key];
                    }
                    break;
                case '[object Boolean]':
                    break;
                case '[object Undefined]':
                    if (obj[_key] == undefined) {
                        delete obj[_key];
                    }
                    break;
                case '[object Null]':
                    if (obj[_key] == null) {
                        delete obj[_key];
                    }
                    delete obj[_key];
                    break;
                case '[object Object]':
                    if (this.isObject(obj[_key])) {
                        delete obj[_key];
                    }
                    break;
                case '[object Array]':
                    if (obj[_key].length == 0) {
                        delete obj[_key];
                    }
                    break;
                default:
            }
        }
        return obj;
    },
        Vue.prototype.timeFormate = time => {
            if (time.toLocaleDateString) {
                var timeStr = time.toLocaleDateString();
                var timeArr = timeStr.split('/');
                timeArr.map((item,index) =>{
                	if(parseInt(item)<10){
                		item = "0"+item;
                		timeArr[index] = item;
                	}
                });
                timeStr = timeArr.join('-');
                return timeStr;
            } else {
                return time;
            }
        },
        // 转换日期+时间
        Vue.prototype.formatDateTime = date => {
            var y = date.getFullYear();  
            var m = date.getMonth() + 1;  
            m = m < 10 ? ('0' + m) : m;  
            var d = date.getDate();  
            d = d < 10 ? ('0' + d) : d;  
            var h = date.getHours();
            h = h < 10 ? ('0' + h) : h;  
            var minute = date.getMinutes();
            minute = minute < 10 ? ('0' + minute) : minute;
            var seconds = date.getSeconds();
            seconds = seconds < 10 ? ('0' + seconds) : seconds;
            return y + '-' + m + '-' + d+' '+h+':'+minute+":"+seconds;  
        },
        Vue.prototype.getTime = time =>{
        	var _date = new Date(time);
        	var h  = _date.getHours();
        	var m = _date.getMinutes();
        	h = h>10?h:'0'+h;
        	m = m>10?m:'0'+m;
        	return h+':'+m;
        },
        Vue.prototype.formatDate = (date, fmt) => {
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
            }
            let o = {
                'M+': date.getMonth() + 1,
                'd+': date.getDate(),
                'h+': date.getHours(),
                'm+': date.getMinutes(),
                's+': date.getSeconds()
            }
            for (let k in o) {
                if (new RegExp(`(${k})`).test(fmt)) {
                    let str = o[k] + ''
                    fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length))
                }
            }
            return fmt
        },
        //数字格式化成带n位小数
        Vue.prototype.formatPrice = (price=0, n=2) => {
            n = isNaN(+n)?0:+n
            price = +price
            if(isNaN(price)){
                return Number(0).toFixed(n)
            }else{
                return Number(price).toFixed(n)
            }
        }
}


export default plugins;



// WEBPACK FOOTER //
// ./src/base/js/plugins.js